<template>
    <div>
      <component :is="currentPage"></component>
    </div>
  </template>
  
  <script>
  import PrivacySummaryZHCN from './zh-CN/PrivacySummary.vue';
  import PrivacySummaryEN from './en/PrivacySummary.vue';
  
  export default {
    data() {
      return {
        currentPage: null,
      };
    },
    created() {
      const userLang = navigator.language || 'en';  // 获取浏览器的语言
      if (userLang.startsWith('zh')) {
        this.currentPage = PrivacySummaryZHCN;  // 如果是中文，加载中文版页面
      } else {
        this.currentPage = PrivacySummaryEN;  // 如果是英文，加载英文版页面
      }
    },
  };
  </script>


// WEBPACK FOOTER //
// src/components/PrivacySummary.vue